import { gql } from "@apollo/client";
import { graphql } from "@apollo/client/react/hoc";
import InterviewRequestFragment from "common/fragments/InterviewRequest";

const QueryRaw = gql`
  query Calendar {
    calendar {
      id
      time_zone_name
      availability_buffer
      availability_buffer_time
      google_synced
      sync_profile_email
      sync_profile_name
      sync_profile_photo_url
      appointment_slots {
        id
        start_time
        end_time
        calendar_synced
      }
      interview_requests {
        ...InterviewRequestFields

        membership {
          slug
          unified_app {
            id
            user {
              id
              profile_picture_url(size: 130)
              full_name
            }
          }
          job {
            id
            name
          }
        }
      }
    }
  }
  ${InterviewRequestFragment}
`;

const Query = graphql(QueryRaw, {
  options: (ownProps) => {
    return {
      fetchPolicy: "network-only",
    };
  },
});

export default Query;
